var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { v4 } from 'uuid';
import { ActorType, ControlEventAction, TextEventSourceType, } from '../../proto/packets.pb';
import { protoTimestamp } from '../common/helpers';
var EventFactory = /** @class */ (function () {
    function EventFactory() {
        this.character = null;
    }
    EventFactory.prototype.getCurrentCharacter = function () {
        return this.character;
    };
    EventFactory.prototype.setCurrentCharacter = function (character) {
        this.character = character;
    };
    EventFactory.prototype.dataChunk = function (chunk, type) {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { dataChunk: { chunk: chunk, type: type } });
    };
    EventFactory.prototype.audioSessionStart = function () {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { control: { action: ControlEventAction.AUDIO_SESSION_START } });
    };
    EventFactory.prototype.audioSessionEnd = function () {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { control: { action: ControlEventAction.AUDIO_SESSION_END } });
    };
    EventFactory.prototype.ttsPlaybackStart = function () {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { control: { action: ControlEventAction.TTS_PLAYBACK_START } });
    };
    EventFactory.prototype.ttsPlaybackEnd = function () {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { control: { action: ControlEventAction.TTS_PLAYBACK_END } });
    };
    EventFactory.prototype.ttsPlaybackMute = function (isMuted) {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { control: {
                action: isMuted
                    ? ControlEventAction.TTS_PLAYBACK_MUTE
                    : ControlEventAction.TTS_PLAYBACK_UNMUTE,
            } });
    };
    EventFactory.prototype.text = function (text) {
        return __assign(__assign({}, this.baseProtoPacket()), { text: {
                sourceType: TextEventSourceType.TYPED_IN,
                text: text,
                final: true,
            } });
    };
    EventFactory.prototype.trigger = function (name, parameters) {
        if (parameters === void 0) { parameters = []; }
        return __assign(__assign({}, this.baseProtoPacket()), { custom: __assign({ name: name }, (parameters.length && { parameters: parameters })) });
    };
    EventFactory.prototype.cancelResponse = function (cancelResponses) {
        return __assign(__assign({}, this.baseProtoPacket({ utteranceId: false, interactionId: false })), { mutation: { cancelResponses: cancelResponses } });
    };
    EventFactory.prototype.baseProtoPacket = function (props) {
        var _a, _b;
        return {
            packetId: __assign(__assign({ packetId: v4() }, (((_a = props === null || props === void 0 ? void 0 : props.utteranceId) !== null && _a !== void 0 ? _a : true) && { utteranceId: v4() })), (((_b = props === null || props === void 0 ? void 0 : props.interactionId) !== null && _b !== void 0 ? _b : true) && { interactionId: v4() })),
            timestamp: protoTimestamp(),
            routing: this.routing(),
        };
    };
    EventFactory.prototype.routing = function () {
        var _a;
        return {
            source: { type: ActorType.PLAYER },
            target: { type: ActorType.AGENT, name: (_a = this.character) === null || _a === void 0 ? void 0 : _a.id },
        };
    };
    return EventFactory;
}());
export { EventFactory };
